import styleInject from '../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".ti-affix {\n  --ti-affix-zIndex: 1000;\n  position: fixed;\n  z-index: var(--ti-affix-zIndex);\n}\n";
styleInject(css_248z);

export { css_248z as default };
